import { CHANGE_STEP, SAVE_REQUEST, SAVE_SUCCESS, SAVE_ERROR } from '../actions/antragActions';

export default function antragReducer(state = {
    isFetching: false,
    success: false,
    message: '',
    step: 0,
    saving: false
}, action) {
    switch (action.type) {
        case SAVE_REQUEST:
            return Object.assign({}, state, {
                saving: true
            });
        case SAVE_SUCCESS:
            return Object.assign({}, state, {
                saving: false
            });
        case SAVE_ERROR:
            return Object.assign({}, state, {
                saving: false
            });
        case CHANGE_STEP:
            return Object.assign({}, state, {
                step: action.step
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducer/antragReducer.js